const faqBtns = document.querySelectorAll('.faq-top-text-btn');
faqBtns.forEach(btn => btn.addEventListener('click', onBtnClick));

function onBtnClick(e) {
  const faqTop = e.currentTarget;
  const faqContainer = faqTop.closest('.faq-list-item');
  const bottomText = faqContainer.querySelector('.faq-bottom-text');
  const faqToggle = faqTop.querySelector('.faq-toggle-symbol');

  document.querySelectorAll('.faq-list-item').forEach(item => {
    if (item !== faqContainer) {
      item.classList.remove('faq-open');
      item.querySelector('.faq-bottom-text').classList.remove('is-visible');
      item.querySelector('.faq-toggle-symbol').textContent = '+';
    }
  });

  bottomText.classList.toggle('is-visible');

  if (bottomText.classList.contains('is-visible')) {
    faqContainer.classList.add('faq-open');
    faqToggle.textContent = '-';
  } else {
    faqContainer.classList.remove('faq-open');
    faqToggle.textContent = '+';
  }
}
